import { useRef, useState } from "react";

export default function NewsletterSection() {
  const formRef = useRef<HTMLFormElement>(null);
  const [status, setStatus] = useState<"idle" | "loading" | "success" | "error">("idle");
  const [errorMsg, setErrorMsg] = useState("");

  const handleSubmit = async (e: React.FormEvent<HTMLFormElement>) => {
    e.preventDefault();
    const form = formRef.current;
    if (!form) return;

    const formData = new FormData(form);
    const honeypot = (formData.get("phone_alt") as string || "").trim();
    if (honeypot) {
      setStatus("success");
      return;
    }

    setStatus("loading");
    setErrorMsg("");

    try {
      const urlEncoded = new URLSearchParams();
      formData.forEach((value, key) => {
        if (key !== "phone_alt") {
          urlEncoded.append(key, value as string);
        }
      });

      const res = await fetch("https://readdy.ai/api/form/d9oprfqftmtnfcfh0bs0", {
        method: "POST",
        headers: { "Content-Type": "application/x-www-form-urlencoded" },
        body: urlEncoded.toString(),
      });

      const text = await res.text();
      let parsed: Record<string, unknown> | null = null;
      try { parsed = JSON.parse(text); } catch { /* ignore */ }

      if (res.ok && parsed && (parsed as Record<string, unknown>).code === "OK") {
        setStatus("success");
        form.reset();
      } else {
        const msg =
          (parsed as Record<string, unknown> | null)?.meta &&
          ((parsed as Record<string, unknown>)?.meta as Record<string, unknown>)?.message
            ? String(((parsed as Record<string, unknown>)?.meta as Record<string, unknown>).message)
            : (parsed as Record<string, unknown> | null)?.message
              ? String((parsed as Record<string, unknown>).message)
              : text || "订阅失败，请稍后再试";
        setErrorMsg(String(msg));
        setStatus("error");
      }
    } catch {
      setErrorMsg("网络错误，请稍后再试");
      setStatus("error");
    }
  };

  return (
    <section className="w-full px-4 md:px-6 py-14 md:py-20 bg-background-900 relative overflow-hidden">
      <div className="absolute inset-0 opacity-10">
        <div
          className="w-full h-full bg-cover bg-center"
          style={{
            backgroundImage:
              "url(https://readdy.ai/api/search-image?query=abstract%20dark%20texture%20with%20subtle%20warm%20red%20glow%20accents%2C%20elegant%20minimal%20pattern%2C%20dark%20atmospheric%20gradient%2C%20cinematic%20background&width=1200&height=600&seq=newsletter-bg&orientation=landscape)",
          }}
        ></div>
      </div>
      <div className="relative z-10 max-w-2xl mx-auto text-center">
        <h2 className="text-2xl md:text-3xl font-heading text-white mb-4">
          订阅<span className="text-primary-400">吃瓜日报</span>
        </h2>
        <p className="text-sm text-background-300 mb-8 leading-relaxed">
          每日精选最热门吃瓜内容，第一时间推送至你的邮箱，不再错过任何精彩爆料
        </p>

        <form ref={formRef} onSubmit={handleSubmit} data-readdy-form="">
          <input type="hidden" name="formId" value="newsletter-sub" />
          <div className="honeypot-field">
            <input type="text" name="phone_alt" tabIndex={-1} autoComplete="off" aria-hidden="true" readOnly />
          </div>
          <div className="flex flex-col sm:flex-row gap-3 max-w-lg mx-auto">
            <input
              type="email"
              name="email"
              required
              placeholder="输入你的邮箱地址"
              className="flex-1 px-5 py-3 rounded-full bg-white/10 border border-white/20 text-white text-sm placeholder:text-background-400 focus:outline-none focus:border-primary-400 transition-colors"
            />
            <button
              type="submit"
              disabled={status === "loading"}
              className="px-8 py-3 rounded-full bg-primary-500 text-white text-sm font-medium hover:bg-primary-600 transition-all disabled:opacity-60 whitespace-nowrap cursor-pointer"
            >
              {status === "loading" ? (
                <span className="flex items-center gap-2">
                  <i className="ri-loader-4-line animate-spin"></i>订阅中...
                </span>
              ) : (
                "立即订阅"
              )}
            </button>
          </div>
          {status === "success" && (
            <p className="mt-4 text-sm text-accent-400">
              <i className="ri-check-line mr-1"></i>订阅成功！感谢你的关注
            </p>
          )}
          {status === "error" && (
            <p className="mt-4 text-sm text-red-400">
              <i className="ri-error-warning-line mr-1"></i>{errorMsg}
            </p>
          )}
        </form>

        <p className="mt-4 text-xs text-background-500">
          已有 <strong className="text-background-300">12,580</strong> 位吃瓜群众订阅
        </p>
      </div>
    </section>
  );
}